import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "error" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "modal-footer justify-content-between" }
const _hoisted_15 = { class: "dropdown dropup" }
const _hoisted_16 = {
  key: 0,
  type: "button",
  class: "btn btn-danger",
  "data-toggle": "dropdown"
}

import { ref, computed, onMounted } from 'vue'
    import { isNullOrWhitespace } from '@common/Common'

    // ---------------- types ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PanelEditor',
  props: {
    SurveyId: {},
    Name: {},
    Description: {},
    Members: {},
    OwnerEmail: {},
    NameError: {},
    ResponseDueDate: {}
  },
  emits: ["deletePanel", "createPanel", "updatePanel", "close"],
  setup(__props: any, { emit: __emit }) {

    class MemberReadModel
    {
        WorkspaceUserId!: number
        Email!: string
        Name!: string
    }

    // ---------------- props / emits ----------------

    const props = __props

    const emit = __emit

    // ---------------- derived props ----------------

    const surveyId = computed(() => props.SurveyId)
    const nameError = computed(() => props.NameError)

    const title = computed(() =>
        surveyId.value > 0
            ? `Edit panel: ${props.Name}`
            : 'Create opinion panel'
    )

    const createVisible = computed(() => surveyId.value === 0)
    const updateVisible = computed(() => surveyId.value !== 0)
    const deleteVisible = computed(() => surveyId.value !== 0)

    // ---------------- local editable state ----------------

    const name = ref<string | null>(null)
    const description = ref<string | null>(null)
    const members = ref<MemberReadModel[]>([])
    const owner = ref<MemberReadModel | null>(null)
    const responseDueDate = ref<string | null>(null)

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        name.value = props.Name
        description.value = props.Description
        members.value = [...props.Members]
        responseDueDate.value = props.ResponseDueDate

        const ownerEmail = props.OwnerEmail

        if (!isNullOrWhitespace(ownerEmail))
        {
            let found = members.value.find(m => m.Email === ownerEmail)

            if (!found)
            {
                found = new MemberReadModel()
                found.Name = ownerEmail
                found.Email = ownerEmail

                members.value.push(found)
            }

            owner.value = found
        }
    })

    // ---------------- actions ----------------

    function deletePanel()
    {
        emit('deletePanel', surveyId.value)
    }

    function createPanel()
    {
        emit('createPanel', {
            Name: name.value,
            Description: description.value,
            OwnerEmail: owner.value?.Email,
            ResponseDueDate: responseDueDate.value
        })
    }

    function updatePanel()
    {
        emit('updatePanel', {
            SurveyId: surveyId.value,
            Name: name.value,
            Description: description.value,
            OwnerEmail: owner.value?.Email,
            ResponseDueDate: responseDueDate.value
        })
    }

    function close()
    {
        emit('close')
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h5", _hoisted_6, _toDisplayString(title.value), 1 /* TEXT */),
            _createElementVNode("button", {
              onClick: close,
              type: "button",
              class: "close"
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[4] || (_cache[4] = _createElementVNode("label", null, "Name", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                type: "text",
                class: "form-control"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  name.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(nameError.value), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[5] || (_cache[5] = _createElementVNode("label", null, "Description", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
                type: "text",
                class: "form-control"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  description.value,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[7] || (_cache[7] = _createElementVNode("label", null, "Owner", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((owner).value = $event)),
                class: "form-control"
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("option", { value: null }, "None", -1 /* CACHED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(members.value, (m) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: m,
                    key: m.Email
                  }, _toDisplayString(m.Name), 9 /* TEXT, PROPS */, _hoisted_12))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, owner.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[8] || (_cache[8] = _createElementVNode("label", null, "Response due date:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((responseDueDate).value = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, responseDueDate.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (deleteVisible.value)
                ? (_openBlock(), _createElementBlock("button", _hoisted_16, "Delete"))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", {
                class: "dropdown-menu",
                role: "menu",
                style: {"padding":"10px"}
              }, [
                _cache[9] || (_cache[9] = _createElementVNode("a", { class: "dropdown-item" }, "Cancel", -1 /* CACHED */)),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: deletePanel
                }, "Confirm")
              ])
            ]),
            _createElementVNode("div", null, [
              (createVisible.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: createPanel,
                    type: "button",
                    class: "btn btn-primary"
                  }, "Create"))
                : _createCommentVNode("v-if", true),
              (updateVisible.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: updatePanel,
                    type: "button",
                    class: "btn btn-primary"
                  }, "Save"))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                onClick: close,
                type: "button",
                class: "btn btn-outline-secondary"
              }, "Cancel")
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})